import React from 'react';
import './NewsAndStoriesToolbar.scss';

interface NewsAndStoriesToolbarProps {
  itemsCount: number;
  itemsText: string;
  children?: React.ReactNode;
}

export const NewsAndStoriesToolbar = ({
  itemsCount,
  itemsText,
  children,
}: NewsAndStoriesToolbarProps) => {
  return (
    <div className='news-and-stories-toolbar'>
      <p className='news-and-stories__count'>{`${itemsCount} ${itemsText}`}</p>
      {children}
    </div>
  );
};
